// AUTO-GENERATED by tools/sync-from-woo.mjs on 2026-09-16 — do not edit.
// Source of truth: Woo - Neckerchief Tool/scoutwise-necker-designer (class-swnd-data.php + assets/svg).
// 'name' is written to the order and reaches production. hex is for rendering only.
window.ScoutwisePalette = [
  {
    "name": "Black",
    "hex": "#000000"
  },
  {
    "name": "White",
    "hex": "#FFFFFF"
  },
  {
    "name": "Dark Navy",
    "hex": "#152442",
    "legacyName": "Dark Nevy"
  },
  {
    "name": "Lemon Yellow",
    "hex": "#faed56"
  },
  {
    "name": "Orange",
    "hex": "#f1b254"
  },
  {
    "name": "Gold",
    "hex": "#CFAF4F"
  },
  {
    "name": "Tangeri",
    "hex": "#d26027"
  },
  {
    "name": "Scarlet",
    "hex": "#eb3323",
    "legacyName": "Skarlet"
  },
  {
    "name": "Chocolate",
    "hex": "#5b3a1b"
  },
  {
    "name": "Maroon",
    "hex": "#631433"
  },
  {
    "name": "Fellowship Purple",
    "hex": "#751a7c"
  },
  {
    "name": "Sky Blue",
    "hex": "#E0F4FF"
  },
  {
    "name": "Royal Blue",
    "hex": "#0e3ba2"
  },
  {
    "name": "Centenary Blue",
    "hex": "#4587B9"
  },
  {
    "name": "Emerald",
    "hex": "#448e50"
  },
  {
    "name": "Scout Green",
    "hex": "#2b663c"
  },
  {
    "name": "Grape",
    "hex": "#7a0164"
  },
  {
    "name": "Charcoal Grey",
    "hex": "#7d7f85"
  },
  {
    "name": "Khaki",
    "hex": "#836f57"
  },
  {
    "name": "Light Grey",
    "hex": "#d1d1d1"
  },
  {
    "name": "Turquoise",
    "hex": "#41bde4"
  },
  {
    "name": "Hi-Vis Yellow",
    "hex": "#e7ff17"
  },
  {
    "name": "Hi-Vis Orange",
    "hex": "#ff9a04"
  },
  {
    "name": "Hi-Vis Green",
    "hex": "#8eff31"
  },
  {
    "name": "Hi-Vis Pink",
    "hex": "#ff52b6"
  },
  {
    "name": "Centenary Gold",
    "hex": "#E3B819"
  },
  {
    "name": "Pink",
    "hex": "#ED729A"
  },
  {
    "name": "Cyan",
    "hex": "#46bce4"
  },
  {
    "name": "Hyacinth",
    "hex": "#F1EFFF"
  },
  {
    "name": "Buttermilk",
    "hex": "#FFEB9C"
  },
  {
    "name": "Cambridge Blue",
    "hex": "#96E6C2"
  },
  {
    "name": "Reflective (Border Only)",
    "hex": "#e0e9e8",
    "allowedSections": "border-or-stripe"
  }
];

/** Swatch by name, tolerating the pre-2026-07-30 misspellings stored on old orders. */
window.ScoutwiseFindSwatch = function (name) {
  return window.ScoutwisePalette.find(c => c.name === name || c.legacyName === name) || null;
};
window.ScoutwiseGetHex = function (name) {
  const s = window.ScoutwiseFindSwatch(name);
  return s ? s.hex : '#cccccc';
};
/** Reflective is border-and-centre-stripe only. The server enforced this on Woo; here the browser is the only gate. */
window.ScoutwiseSwatchAllowedFor = function (swatch, sectionName) {
  if (!swatch.allowedSections) return true;
  if (swatch.allowedSections === 'border-or-stripe') return /border|stripe/i.test(sectionName);
  return true;
};
